import VerifyInItemAdjustment from "../../../../components/@documents/item_adjustments/VerifyInItemAdjustment";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemAdjustmentVerifyInPage() {

    return (
        <VerifyInItemAdjustment 
            routeType={routeTypes.admin}
        />
    )
}